import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const getClientApi = createAsyncThunk('getclientStatistics',
    async (object, { dispatch, getState }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingClientDetail())
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({name: object?.name})
        };
        fetch(domainUrl + `/viewAllProProjects`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(clientDetailResponse(result?.data))
                    dispatch(setPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(clientDetailClear())
                message.error(error) 
            })
    }
)


const GetClientApiSlice = createSlice({
    name: 'Clientgetapi',
    initialState: {
        clientData: null,
        loadingclient: false,
        pagination:{
            pageNo:1,
            pageSize: 10,
            totalRecords:0,
        },
        filters: {
            name: '',
        },
    },
    reducers: {
        gettingClientDetail: state => {
            state.loadingclient=true
            state.clientData=null
        },
        clientDetailResponse: (state, action)=>{
            state.clientData= action.payload
            state.loadingclient= false
        },
        clientDetailClear: (state)=>{
            state.clientData= null
            state.loadingclient= false
        },
        changeJobDetailFilters: (state, action) => {
            state.filters = action.payload
        },
        setPages:(state, action)=>{
            state.pagination= action.payload
        },
    },
})
export const { 
    gettingClientDetail, clientDetailResponse, clientDetailClear,
    changeJobDetailFilters, setPages
} = GetClientApiSlice.actions;
export default GetClientApiSlice.reducer;